<div class="container-fluid d-flex p-0">
    <app-side-bar></app-side-bar>
    <ng-container>
        <div style="padding: 15px; margin: 5px;width: -webkit-fill-available;">
            <div class="main-heading">
                <h1>Sales And Volume DashBoard</h1>
            </div>

            <!-- <div style="margin-bottom: 20px;">
                <a routerLink="/errordashboard" class="link-card">Back</a>
            </div> -->

            <div class="dropdown" style="margin: 10px 0px;">
                <p-dropdown autoWidth="false" [options]="sourceDropdownOptions" [(ngModel)]="selectedSource"
                    (onChange)="filterData()">
                </p-dropdown>
            </div>

            <div class="card">
                <p-table [value]="filteredData" [tableStyle]="{'min-width': '60rem'}" [paginator]="true" [rows]="10"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="[10, 20, 50]" [loading]="loading">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>NDA Number</th>
                            <th>Brand Name</th>
                            <th>Active Ingredient</th>
                            <th>Route Of Administration</th>
                            <th>Dosage Forms</th>
                            <th>5 year sales</th>
                            <th>5 year volume</th>
                            <th>View More</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>{{ rowData['NDA number'] }}</td>
                            <td>{{ rowData['Brand Name'] }}</td>
                            <td>{{ rowData['Active Ingredient'] }}</td>
                            <td>{{ rowData['Route of Administration'] }}</td>
                            <td>{{ rowData['Dosage forms'] }}</td>
                            <td>
                                <!-- <table border="1">
                                    <thead>
                                        <tr>
                                            <th>Strengths (mg)</th>
                                            <th *ngFor="let year of getYears()">{{ year }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let strengthKey of getStrengthKeys()">
                                            <td>{{ strengthKey.trim() }}</td>
                                            <td *ngFor="let year of getYears()">
                                                {{ rowData['5 year sales']['value']['Strengths
                                                (mg)'][strengthKey][year]}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> -->

                                <!-- <div>
                                    <table border="1">
                                        <thead>
                                            <tr>
                                                <th>Strengths (mg)</th>
                                                <th>2017</th>
                                                <th>2018</th>
                                                <th>2019</th>
                                                <th>2020</th>
                                                <th>2021</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                *ngFor="let item of rowData['5 year sales']['value']['Strengths (mg)'] | keyvalue">
                                                <td>{{ item.key }}</td>
                                                <td>{{ item.value['2017'] }}</td>
                                                <td>{{ item.value['2018'] }}</td>
                                                <td>{{ item.value['2019'] }}</td>
                                                <td>{{ item.value['2020'] }}</td>
                                                <td>{{ item.value['2021'] }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> -->


                                <button (click)="showSalesDialog(rowData)" icon="pi pi-external-link" label="Show">Show
                                    More</button>
                                <p-dialog *ngIf="rowData.new_sales" header="5 year sales"
                                    [(visible)]="rowData.new_sales" [style]="{width: '50vw'}">
                                    <table border="1"
                                        *ngIf="rowData['5 year sales'] && rowData['5 year sales']['value']">
                                        <thead>
                                            <tr>
                                                <th>{{ getStrengthsHeaderText(rowData['5 year sales']) }}</th>
                                                <th
                                                    *ngFor="let year of getYears(rowData['5 year sales']['value']['Strengths (mg)'])">
                                                    {{ year }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container
                                                *ngFor="let strength of rowData['5 year sales']['value']['Strengths (mg)']">
                                                <ng-container *ngFor="let strengthData of strength | keyvalue">
                                                    <tr>
                                                        <td>{{ strengthData.key }}</td>
                                                        <td
                                                            *ngFor="let year of getYears(rowData['5 year sales']['value']['Strengths (mg)'])">
                                                            {{ strengthData.value[year] }}
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </ng-container>
                                        </tbody>
                                    </table>


                                    <!-- <table border="1"
                                        *ngIf="rowData['5 year sales'] && rowData['5 year sales']['value']">
                                        <thead>
                                            <tr>
                                                <th>Strengths (mg)</th>
                                                <th *ngFor="let year of ['2017', '2018', '2019', '2020', '2021']">{{
                                                    year }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container
                                                *ngFor="let strength of rowData['5 year sales']['value']['Strengths (mg)']">
                                                <ng-container *ngFor="let strengthData of strength | keyvalue">
                                                    <tr>
                                                        <td>{{ strengthData.key }}</td>
                                                        <td
                                                            *ngFor="let year of ['2017', '2018', '2019', '2020', '2021']">
                                                            {{ strengthData.value[year] }}
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </ng-container>
                                        </tbody>
                                    </table> -->


                                </p-dialog>
                            </td>
                            <td>
                                <button (click)="showVolumeDialog(rowData)" icon="pi pi-external-link" label="Show">Show
                                    More</button>
                                <p-dialog *ngIf="rowData.new_volume" header="5 year volume"
                                    [(visible)]="rowData.new_volume" [style]="{width: '50vw'}">
                                    <table border="1"
                                        *ngIf="rowData['5 year volume'] && rowData['5 year volume']['value']">
                                        <thead>
                                            <tr>
                                                <th>{{ getStrengthsHeaderText(rowData['5 year volume']) }}</th>

                                                <th
                                                    *ngFor="let year of getYears(rowData['5 year volume']['value']['Strengths (mg)'])">
                                                    {{ year }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <ng-container
                                                *ngFor="let strength of rowData['5 year volume']['value']['Strengths (mg)']">
                                                <ng-container *ngFor="let strengthData of strength | keyvalue">
                                                    <tr>
                                                        <td>{{ strengthData.key }}</td>
                                                        <td
                                                            *ngFor="let year of getYears(rowData['5 year volume']['value']['Strengths (mg)'])">
                                                            {{ strengthData.value[year] }}
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </ng-container>
                                        </tbody>
                                    </table>
                                </p-dialog>

                            </td>
                            <td><button class="btn btn-primary"
                                    (click)="redirectToOtherPage(rowData['Brand Name'],rowData['NDA number'])">View
                                    More</button>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="8" style="text-align: center;">
                                NO DATA FOUND
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="paginatorleft">
                        <p-button type="button" icon="pi pi-plus" styleClass="p-button-text"></p-button>
                    </ng-template>
                    <ng-template pTemplate="paginatorright">
                        <p-button type="button" icon="pi pi-cloud" styleClass="p-button-text"></p-button>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </ng-container>
</div>